import React from "react";
import {
  View,
  ScrollView,
  TouchableOpacity} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import FormattedText from "../../components/FormattedText";
import { Linking } from "react-native";
import commonStyles from "../../styles/commonStyles";
import { statesArray } from "../Profile/Address/statesArray";
import { SafeAreaView } from "react-native-safe-area-context";
import AppText from "../../components/AppText";

export const calculateAcres = (
  data: { state: string; remainingAcres: number }[]
) => {
  const stateSums: Record<string, number> = {};

  data.forEach((item) => {
    const stateCode = item.state;
    const stateObject = statesArray.find((state) => state.value === stateCode);

    if (stateObject) {
      const stateName = stateObject.name;
      stateSums[stateName] = (stateSums[stateName] || 0) + item.remainingAcres;
    }
  });

  const totalAcreage = Object.values(stateSums).reduce(
    (acc, curr) => acc + curr,
    0
  );

  const stateArray = Object.entries(stateSums).map(([state, totalAcres]) => ({
    name: state,
    totalAcreage: totalAcres}));

  stateArray.sort((a, b) => b.totalAcreage - a.totalAcreage);

  return { stateArray, totalAcreage };
};

const LandBank: React.FC<any> = ({ navigation, route }) => {
  const { property } = route.params;

  const { stateArray: results, totalAcreage } = calculateAcres(property);

  const openLink = async (url: string) => {
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
    } else {
      console.log("Don't know how to open URI: " + url);
    }
  };

  return (
    <SafeAreaView edges={[ "bottom", "left", "right"]} style={[commonStyles.flex1, commonStyles.screenBottomGap]}>
      <View style={commonStyles.container}>
        <TouchableOpacity
          style={commonStyles.subHeaderContainer}
          onPress={() => navigation.goBack()}
        >
          <AntDesign name="left" size={24} color="black" />
          <AppText style={commonStyles.subHeader}>Your Land Bank</AppText>
        </TouchableOpacity>
        <ScrollView>
          <View
            style={[
              commonStyles.subContainer,
              commonStyles.p14,
              commonStyles.mlar2,
              commonStyles.mt5,
            ]}
          >
            {results.map((result, index) => (
              <View style={commonStyles.subDetails} key={index}>
                <AppText style={commonStyles.subTitle}>{result.name}</AppText>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <FormattedText
                    value={result.totalAcreage}
                    type="number"
                    style={commonStyles.subValue}
                  />
                  <AppText style={commonStyles.subValue}> acres</AppText>
                </View>
              </View>
            ))}
            <View style={commonStyles.subDetails}>
              <AppText
                style={[
                  commonStyles.subTitle,
                  commonStyles.boldText,
                  { color: "rgb(80, 80, 80)" },
                ]}
              >
                Total
              </AppText>
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <FormattedText
                  value={totalAcreage}
                  type="number"
                  style={commonStyles.subValue}
                />
                <AppText style={commonStyles.subValue}> acres</AppText>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default LandBank;
